import { REQUEST_MEDIA_REPROCESSING, RECIEVE_MEDIA_REPROCESSING } from '../constants/actionTypes';
import { canReprocessScene } from './reprocessScene';
import { canReprocessDataset } from './reprocessDataset';
import { showReprocessingModal } from './modal';
import { generateReprocessingDialogText, statusOk } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestReprocessMedia = (scene, sceneMediaID) => ({
    type: REQUEST_MEDIA_REPROCESSING,
    scene: scene,
    sceneMediaID: sceneMediaID
});

const recieveReprocessMedia = (scene, sceneMediaID) => ({
    type: RECIEVE_MEDIA_REPROCESSING,
    scene: scene,
    sceneMediaID: sceneMediaID
});

// Action Logic
export const canReprocessMedia = (sceneMedia, sceneMediaID) => {
    // If the scene is reprocessing then so is this media. The call is redundant
    if (!canReprocessScene(sceneMedia)) {
        return false;
    }

    // Can't reprocess undefined items
    const item = sceneMedia.mediaItems.find(item => item.sceneMediaID === sceneMediaID);
    if (!item) {
        return false;
    }

    // If the medias' dataset is reprocessing then so is this media. The call is redundant
    if (!canReprocessDataset(sceneMedia, item.datasetNum)) {
        return false;
    }

    // If the item is reprocessing then it cant reprocess again
    if (item.reprocessing) {
        return false;
    }

    return true;
};

const reprocessMedia = (scene, sceneMediaID) => (dispatch) => {
    dispatch(requestReprocessMedia(scene, sceneMediaID));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}/media/${sceneMediaID}`, {method: 'PUT'})
        .then(resp => statusOk(resp, 301))
        .then(
            () => dispatch(recieveReprocessMedia(scene, sceneMediaID)),
            err => {
                dispatch(recieveReprocessMedia(scene, sceneMediaID));   // Promises should realy have a .finally()
                return err;
            }
        );
};

export const reprocessSelectedMediaItemIfOK = scene => (dispatch, getState) => {
    const state = getState();
    const sceneMedia = state.mediaByScene[scene];

    // Get selected mediaItems
    const selectedMediaItemIds = sceneMedia.mediaItems.filter(m => m.selected).map(m => m.sceneMediaID);
    
    // Dispatch per each unique dataset
    const reprocessPromises = selectedMediaItemIds.map(id => canReprocessMedia(sceneMedia, id) 
        ? dispatch(reprocessMedia(scene, id))
        : Promise.resolve());
    
    // Generate and show the reprocessing dialog
    Promise.all(reprocessPromises)
        .then(results => generateReprocessingDialogText(results, 'media items'))
        .then(text => dispatch(showReprocessingModal(text)));
};



// WEBPACK FOOTER //
// ./src/actions/reprocessMediaItem.js